import React, { useContext, useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { AppContext } from "../contexts/AppContext";
import axiosHttp from "../config/axios.interceptor";
import { errorResponseMessage } from "./const.prop";
import { parseHtmlAndReplaceEmpty } from "../../utils/application-helper";
import DOMPurify from "dompurify";
import { AuthContext } from "../contexts/AuthContext";
import LinkPreviewCard from "../components/LinkPreviewCard";
import { useSelector } from "react-redux";

const PostText = ({ data }) => {
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const [value, setValue] = useState(data ? data?.description : "");
  const [parsedValue, setParsedValue] = useState("");
  const [extractedUrl, setExtractedUrl] = useState([]);
  const [categoryId, setCategoryId] = useState(
    data?.skillCategoryId ? data?.skillCategoryId : ""
  );
  const { categoryList } = useSelector((state) => state.utilData);

  useEffect(() => {
    if (value) {
      setTimeout(() => {
        fetchPreviewCards(parseHtmlAndReplaceEmpty(value));
      }, 1000);
      setParsedValue(parseHtmlAndReplaceEmpty(value));
    }
  }, [value]);

  const fetchPreviewCards = (value) => {
    let url = [];
    const splittedValue = value.split(" ");
    splittedValue.map((item) => {
      if (
        item.startsWith("www.") ||
        item.startsWith("https") ||
        item.startsWith("http")
      ) {
        item.startsWith("www") ? url.push(`https://${item}`) : url.push(item);
      }
    });
    setExtractedUrl(url);
  };

  const postHandler = () => {
    if (!parsedValue.trim()) {
      appContext.updateNotificationState({
        type: "error",
        message: "Please add the post!",
        show: true,
      });
      return;
    }
    const sanitizedHtml = DOMPurify.sanitize(value);
    appContext.updateLoaderState(true);
    if (data?.id) {
      axiosHttp
        .post(`post-data/${data.id}`, {
          type: "text",
          text: sanitizedHtml,
          url: "",
          skillCategoryId: categoryId,
        })
        .then((postResponse) => {
          if (postResponse.status === 201) {
            appContext.updateLoaderState(false);
            appContext.updateModalState();
          }
        })
        .catch((error) => {
          if (error.response.status === 429) {
            appContext.updateNotificationState({
              show: true,
              message: errorResponseMessage(error),
              type: "error",
            });
            authContext.logout();
          }
          if (error.response?.status >= 500) {
            appContext.updateNotificationState({
              show: true,
              message: "Something went wrong, please try again later.",
              type: "error",
            });
            appContext.updateLoaderState(false);
            return;
          }
          appContext.updateNotificationState({
            type: "error",
            message: errorResponseMessage(error),
            show: true,
          });
          appContext.updateLoaderState(false);
        });
    } else {
      axiosHttp
        .post("post-data", {
          type: "text",
          text: sanitizedHtml,
          url: "",
          skillCategoryId: categoryId,
        })
        .then((postResponse) => {
          if (postResponse.status === 201) {
            appContext.updateLoaderState(false);
            appContext.updateModalState();
          }
        })
        .catch((error) => {
          if (error.response.status === 429) {
            appContext.updateNotificationState({
              show: true,
              message: errorResponseMessage(error),
              type: "error",
            });
            authContext.logout();
          }
          if (error.response?.status >= 500) {
            appContext.updateNotificationState({
              show: true,
              message: "Something went wrong, please try again later.",
              type: "error",
            });
            appContext.updateLoaderState(false);
            return;
          }
          appContext.updateNotificationState({
            type: "error",
            message: errorResponseMessage(error),
            show: true,
          });
          appContext.updateLoaderState(false);
        });
    }
  };

  const handleClose = (url) => {
    const filteredUrl = extractedUrl.filter((item) => {
      return url !== item;
    });
    setExtractedUrl(filteredUrl);
  };

  const toolbarOptions = [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline"],
    [{ list: "ordered" }, { list: "bullet" }],
  ];

  return (
    <>
      <div className="modal-body">
        <select
          className="form-control custom-select mb-4"
          onChange={(e) => setCategoryId(e.target.value)}
          disabled={
            data?.skillCategoryId === "680c89f84f3447f6da04284f" ? true : false
          }
          value={categoryId}
        >
          <option value="">Select category</option>
          {categoryList.map((item) => {
            return <option value={item?._id}>{item?.name}</option>;
          })}
        </select>

        <div className="card ">
          <ReactQuill
            theme="snow"
            value={value}
            onChange={setValue}
            modules={{
              toolbar: toolbarOptions,
            }}
          />
          {extractedUrl.length > 0 && (
            <div className="link-card-preview p-3">
              {extractedUrl.length > 0 &&
                extractedUrl.map((item) => {
                  return (
                    <LinkPreviewCard url={item} handleClose={handleClose} />
                  );
                })}
            </div>
          )}
        </div>
      </div>
      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-outline-primary prime-btn"
          data-dismiss="modal"
          onClick={appContext.updateModalState}
        >
          Cancel
        </button>
        <button
          disabled={
            appContext.loaderState || !parsedValue.trim() || categoryId === ""
          }
          onClick={postHandler}
          type="button"
          className="btn btn-outline-primary modal-btn"
        >
          Done
        </button>
      </div>
    </>
  );
};

export default PostText;
